import React from 'react';
import PropTypes from 'prop-types';
import { Motion, spring } from 'react-motion';
import styled, { css } from 'styled-components';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import Poller from './Poller';
import Ellipsis from './Loader';
import hireIcon from '../images/hire-icon.svg';

/*todo make sure tradie icons arent too squished on smaller devices */

const IconStyle = css`
  border-radius: 5px;
  width: 43px;
  height: 30px;
  margin: 0 3px 12px;
  display: inline-block;
  border: 1px solid #ececec;
  color: #434447;
  background-color: #ececec;
  color: #434447;
  font-size: 12px;
  text-align: center;
`;

export const TradieIcon = styled.img`
  ${IconStyle};
`;

export const MoreTradiesIcon = styled.div`
  ${IconStyle};
  padding: 8px 0;
`;

const FadeContainer = styled(TransitionGroup)`
  display: flex;
  justify-content: center;
  align-content: flex-start;
  flex-wrap: wrap;
  padding: 10px 5px 0;

  .fade-enter {
    opacity: 0.01;
  }

  .fade-enter.fade-enter-active {
    opacity: 1;
    transition: opacity 300ms ease-in;
  }

  .fade-exit {
    opacity: 1;
  }

  .fade-exit.fade-exit-active {
    opacity: 0.01;
    transition: opacity 800ms ease-in;
  }
`;

const Fade = ({ children, ...props }) => (
  <CSSTransition {...props} timeout={1000} classNames="fade">
    {children}
  </CSSTransition>
);

Fade.propTypes = {
  children: PropTypes.node
};

export class InviteVisualiztion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasSeenAnimation: props.hasSeenAnimation,
      counter: 0
    };
  }

  componentDidMount() {
    // Preload the images into the browser case for slower (mobile connections)
    if (Array.isArray(this.props.thumbnails) && typeof Image !== 'undefined') {
      this.props.thumbnails.map(url => {
        const img = new Image();
        img.src = url;
      });
    }

    if (!this.state.hasSeenAnimation) {
      this.interval = setInterval(() => {
        //coin toss to determine if tradie icon should be added yet (make timing look more natural/random)
        if (Math.round(this.props.random())) {
          this.props.onAnimationStarted();
          this.setState({
            counter: this.state.counter + 1
          });
        }

        if (this.state.counter >= this.props.max) {
          clearInterval(this.interval);
          this.props.onAnimationFinished();
        }
      }, 750);
    } else {
      this.setState({
        counter: this.props.max || 7
      });
      this.props.onAnimationFinished();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.state.hasSeenAnimation) {
      this.setState({
        counter: this.props.max
      });
    } else if (this.state.counter > this.props.max) {
      this.setState({
        counter: this.props.max
      });
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  static propTypes = {
    suburb: PropTypes.string,
    invitedCount: PropTypes.number,
    thumbnails: PropTypes.arrayOf(PropTypes.string),
    max: PropTypes.number,
    onAnimationStarted: PropTypes.func,
    onAnimationFinished: PropTypes.func,
    hasSeenAnimation: PropTypes.bool,
    random: PropTypes.func
  };

  static defaultProps = {
    max: 6,
    random: Math.random,
    thumbnails: []
  };

  render() {
    const { thumbnails = [], invitedCount = 0, max } = this.props;
    const { counter } = this.state;
    return (
      <FadeContainer>
        {thumbnails.slice(0, Math.min(counter, max - 1)).map((item, i) => (
          <Fade key={i}>
            <TradieIcon
              src={item}
              onError={e => {
                e.target.src = hireIcon;
                e.target.style = 'padding: 5px';
              }}
            />
          </Fade>
        ))}
        {counter >= max &&
          (invitedCount > max ? (
            <Fade>
              <MoreTradiesIcon>
                <Motion
                  defaultStyle={{ count: 0 }}
                  style={{
                    count: spring(Math.max(invitedCount - max, 0), {
                      stiffness: 20,
                      dampening: 50
                    })
                  }}
                >
                  {value => <div>+{Math.round(value.count)}</div>}
                </Motion>
              </MoreTradiesIcon>
            </Fade>
          ) : (
            <Fade>
              <MoreTradiesIcon>
                <Ellipsis size={6} />
              </MoreTradiesIcon>
            </Fade>
          ))}
      </FadeContainer>
    );
  }
}
export default Poller((props, schedule) => {
  const { fetchJobInvitations, invitedCount } = props;
  fetchJobInvitations();
  const duration = invitedCount === 0 ? 5000 : 60000;
  schedule(duration);
})(InviteVisualiztion);
